import { FC, ReactNode } from 'react';
import { localeStore } from 'src/mobx/localesStore';
import './style.scss';

interface IProps {
  title: string;
  children: ReactNode;
}

const PlatesSection: FC<IProps> = ({ title, children }) => {
  return (
    <div className="plate-section">
      <p className="plate-section__title letter-spacing-12">{localeStore.t(title)}</p>
      <div className="plate-section__container">{children}</div>
    </div>
  );
};

export default PlatesSection;
